export default class ShortcutsModel {
  constructor() {
    // DISPLAY
    this.hideShortcuts = () => {};
    this.currentLevel = 'none';

    // GAME
    this.seasonsUnlocked = false;
    this.cutscenesEnabled = true;
    this.countdownEnabled = true;

    // AUDIO
    this.sound = true;
    this.sfx = true;
    this.music = true;
    this.vo = true;

    this.captions = true;

    // LEVELS
    this.nextLevel = () => {};
    this.launchLevel = [];
  }
}
